import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import {
  COMPANY_ID,
  EMPLOYEE_ID,
  EVENT_ID,
  SITE_TOKEN,
  SITE_ID,
} from '@config/global-constants';
import { TokenSessionService } from '@app/shared/services';
import { lazyInject } from '@app/shared/decorators';
import { NavigateService } from '@app/shared/services/navigate/navigate.service';
import { appModeInfo } from '@app/shared/utils/app.utils';

@Injectable()
export class LoginSuccess {
  @lazyInject(NavigateService) public navigateService: NavigateService;
  @lazyInject(TokenSessionService)
  public tokenSessionService: TokenSessionService;

  public canActivate(route: ActivatedRouteSnapshot): boolean {
    if (
      !this.tokenSessionService.getToken(COMPANY_ID) ||
      !this.tokenSessionService.getToken(SITE_TOKEN) ||
      !this.tokenSessionService.getToken(SITE_ID) ||
      !this.tokenSessionService.getToken(EMPLOYEE_ID)
    ) {
      const { isDev } = appModeInfo();

      if (!isDev) {
        // not remove COMPANY_ID, SITE_ID, SITE_TOKEN in dev mode for easier testing
        // to avoid can't login successfully after url changed by hand
        this.tokenSessionService.removeToken(SITE_ID);
        this.tokenSessionService.removeToken(SITE_TOKEN);
        this.tokenSessionService.removeToken(COMPANY_ID);
      }

      this.tokenSessionService.removeToken(EMPLOYEE_ID);
      this.tokenSessionService.removeToken(EVENT_ID);

      this.navigateLogin(route);
      return false;
    }

    return true;
  }

  protected navigateLogin(route: ActivatedRouteSnapshot): void {
    const navigateBackUrl = route['_routerState']?.url;

    this.navigateService.navigateToPage(navigateBackUrl, 'sign-in');
  }
}
